import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export class TableRow extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    style: PropTypes.object,
    dataTestId: PropTypes.string,
    className: PropTypes.string,
  };

  render() {
    const { children, className, dataTestId, style } = this.props;
    const tableRowClass = classNames("TableRow", className);
    return (
      <tr
        className={tableRowClass}
        data-testid={dataTestId}
        style={{ ...style }}
      >
        {children}
      </tr>
    );
  }
}

export default TableRow;
